import { Fancybox } from '@fancyapps/ui'
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
 
Alpine.plugin(collapse)
Alpine.plugin(intersect)
Alpine.plugin(focus)

Alpine.data('clickTracking', () => ({
    async registerClick(contentId: number, buttonKey: string) {
        try {
            const response = await fetch(`/api/clicktracking?contentId=${encodeURIComponent(contentId)}&buttonKey=${encodeURIComponent(buttonKey)}`, {
                method: 'POST',
                keepalive: true
            })
            if (!response.ok) {
                console.error('Click tracking failed with status', response.status)
            }
        } catch (error) {
            console.error('Click tracking failed', error)
        }
    }
}))

Alpine.start()

Fancybox.bind('[data-fancybox]', {})

if (document.querySelectorAll('.swiper').length > 0) {
    import('./swipers').then((x) => {
        x.initSwipers()
    })
}

if (document.querySelectorAll('.mux-player').length > 0) {
    import('./muxVideo').then((x) => {
        x.initMuxVideo()
    })
}

if (document.querySelectorAll('#QuizSkill').length > 0) {
    import('./skillQuiz').then((x) => {
        x.initQuiz()
    })
}

if (document.querySelectorAll('#QuizMatching').length > 0) {
    import('./matchingQuiz').then((x) => {
        x.initQuiz()
    })
}